var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-container"},[_c('el-tabs',{attrs:{"type":"border-card"},on:{"tab-click":_vm.clickTab}},[_c('el-tab-pane',{attrs:{"label":"血压检测"}},[_c(_vm.currentView1,{tag:"component",attrs:{"pInfo":_vm.pInfo}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }